import { SET_SIDEBAR_OPEN, useVideoUIDispatch } from "../../VideoUIContext";
import VideoUIIntroDialog from "./VideoUIIntroDialog";
import { useBreakpoint } from "@core/hooks/useBreakpoint";
import { MeetingDetails } from "@platform/features/video/types/video.types";
import { useLocalVideo } from "amazon-chime-sdk-component-library-react";
import { useVideoStreamManager } from "../../../video/hooks/useVideoStreamManager";

type Props = {
  meetingDetails: MeetingDetails;
};

export function VideoUIIntroDialogContainer({ meetingDetails }: Props) {
  const dispatch = useVideoUIDispatch();
  const { isVideoEnabled } = useLocalVideo();
  const { stopVideoStream } = useVideoStreamManager();

  const isMdScreen = useBreakpoint("md");

  const handleClose = async () => {
    // Handle video state when modal is closed
    try {
      // If video is not enabled, ensure the video stream is stopped
      if (!isVideoEnabled) {
        console.log('Intro dialog closed - video is disabled, stopping video stream');
        await stopVideoStream();
      }
    } catch (error) {
      console.error('Error stopping video stream after intro dialog close:', error);
    }

    // Handle sidebar state
    if (isMdScreen) {
      dispatch({ type: SET_SIDEBAR_OPEN, payload: { activeTab: "materials" } });
    }
  };

  return (
    <VideoUIIntroDialog meetingDetails={meetingDetails} onClose={handleClose} />
  );
}

export default VideoUIIntroDialogContainer;
